import { PenaltyDuration } from './game-event';
import { isFloorball, Sport } from './sport';

// Floorball's IFF Rules 2026 penalties: the bench penalty (2 minutes, or 2+2
// for a major one) is what takes a player off the rink; a personal penalty can
// come on top of it and does not change the number of players.
export type PersonalPenalty =
  | 'ten_minutes'
  | 'technical_match_penalty'
  | 'match_penalty';

export interface PersonalPenaltyOption {
  value: PersonalPenalty;
  label: string;
  // the bench penalty this personal penalty is always imposed with
  benchPenalty: PenaltyDuration;
}

const ICE_HOCKEY_PENALTY_DURATIONS: PenaltyDuration[] = [
  '0',
  '2',
  '2+2',
  '5',
  '10',
  '20'
];

const FLOORBALL_PENALTY_DURATIONS: PenaltyDuration[] = ['2', '2+2'];

const FLOORBALL_PERSONAL_PENALTIES: PersonalPenaltyOption[] = [
  {
    value: 'ten_minutes',
    label: '10-minute personal penalty',
    benchPenalty: '2'
  },
  {
    value: 'technical_match_penalty',
    label: 'Technical match penalty',
    benchPenalty: '2+2'
  },
  { value: 'match_penalty', label: 'Match penalty', benchPenalty: '2+2' }
];

export function penaltyDurationsFor(sport: Sport): PenaltyDuration[] {
  return isFloorball(sport)
    ? FLOORBALL_PENALTY_DURATIONS
    : ICE_HOCKEY_PENALTY_DURATIONS;
}

export function personalPenaltiesFor(sport: Sport): PersonalPenaltyOption[] {
  return isFloorball(sport) ? FLOORBALL_PERSONAL_PENALTIES : [];
}

export function benchPenaltyFor(
  personalPenalty: PersonalPenalty
): PenaltyDuration | undefined {
  return FLOORBALL_PERSONAL_PENALTIES.find(
    (option) => option.value === personalPenalty
  )?.benchPenalty;
}
